import React, {useEffect} from 'react'
import { useRouteNode } from 'react-router5'

import Login from '../login/login'

import PostFeed from '../post/postfeed'
import Post from '../post/post'
import Profile from '../profile/profile'

import Trending from '../trending/trending'
import Explore from '../explore/explore'
import Carto from '../carto/carto'
import AppSettings from '../app_settings/app_settings'
import Editor from '../editor/editor'
import { Grid } from '../grid/grid'

import ProfilContributeur from '../post/contributorProfil'

import NotFound from './NotFound'
import Pin from "../login/pin";

import IM from "../IM/IM";
import useUserActivity from "../Hooks/useUserActivity";
import WindowFocusHandler from "../utils/WindowFocusHandler";

function Main({ portal_ref }) {

    useUserActivity();

    const { route, router } = useRouteNode('')
    const topRouteName = route.name.split('.')[0]
    WindowFocusHandler();
    if (topRouteName === 'grid') return <Grid router={router} name="grid" />

    if (topRouteName === 'login') return <Login router={router} />
    if(topRouteName === 'pin'){return <Pin router={router} setPin={false}/>}

    if(topRouteName === 'setPin'){return <Pin router={router} setPin={true}/>}
    if (topRouteName === 'profile') return <Profile />
    if (topRouteName === 'postfeed') return <PostFeed portal_ref={portal_ref} />
    if (topRouteName === 'contributor') return <ProfilContributeur />
    if (topRouteName === 'post') return <Post />

    if (topRouteName === 'carto') return <Carto />
    if (topRouteName === 'explore') return <Explore portal_ref={portal_ref} />
    if (topRouteName === 'trending') return <Trending portal_ref={portal_ref} />

    if (topRouteName === 'settings') return <AppSettings />
    if (topRouteName === 'editor') return <Editor />

    if (topRouteName === 'IM') return <IM />
    return <NotFound />
}

export default Main
